import Dot from "@assets/svg/Dot";
import CustomText from "@components/CustomText";
import color from "@constants/color";
import React from "react";
import { Modal, Image, TouchableNativeFeedback, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

const MarkingInfoModal = (props) => {
  const { visible, data, onSubmit = () => {} } = props;
  const insets = useSafeAreaInsets();

  return (
    <>
      <Modal
        statusBarTranslucent
        navigationBarTranslucent
        animationType="slide"
        transparent={true}
        visible={visible}
      >
        <View
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            flex: 1,
          }}
        >
          <View
            style={{
              backgroundColor: color.white,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              width: "100%",
              padding: 16,
              paddingBottom: 16 + insets.bottom,
              position: "absolute",
              bottom: 0,
            }}
          >
            <View style={{ position: "absolute", left: 20, top: -68 }}>
              <Image
                source={{
                  uri: data?.imageUrl,
                }}
                style={{ height: 160, width: 160 }}
                resizeMode="cover"
              />
            </View>
            <View style={{ marginTop: 90 }}>
              <CustomText
                variant="title_20"
                style={{ color: "rgba(0, 0, 0, 0.86)" }}
              >
                {data?.title}
              </CustomText>
              <View
                style={{
                  borderBottomColor: "rgba(0, 0, 0, 0.10)",
                  borderBottomWidth: 1,
                  marginBottom: 20,
                  marginTop: 2,
                  width: 245,
                }}
              />
            </View>
            {data?.list &&
              Array.isArray(data?.list) &&
              data?.list.map((l) => (
                <View style={{ flexDirection: "row" }}>
                  <View style={{ marginRight: 5, marginTop: 10 }}>
                    <Dot fill="rgba(0, 0, 0, 1)" />
                  </View>
                  <CustomText
                    variant="body_text_1"
                    style={{ color: "rgba(0, 0, 0, 0.86)" }}
                  >
                    {l}
                  </CustomText>
                </View>
              ))}
            <TouchableNativeFeedback
              testID="marking"
              onPress={() => onSubmit()}
            >
              <View
                style={{
                  backgroundColor: "rgba(0, 171, 89, 1)",
                  borderRadius: 8,
                  alignItems: "center",
                  marginTop: 40,
                  paddingVertical: 10,
                }}
              >
                <CustomText variant="title_18" style={{ color: color.white }}>
                  {"मार्किंग पूरी करें "}
                </CustomText>
              </View>
            </TouchableNativeFeedback>
          </View>
        </View>
      </Modal>
    </>
  );
};

export default MarkingInfoModal;
